import { 
  statusMoughataaStart,
  statusMoughataaSuccess,
  statusMoughataaFailure 
} from "./moughataaSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getMoughataasApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMoughataaStart())
    const response = await get(`moughataa`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMoughataaSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMoughataaFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMoughataaFailure(errData))
      return [errData]
    }
  }
}

export const AddMoughataaApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMoughataaStart())
    const response = await post(`moughataa`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMoughataaSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMoughataaFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMoughataaFailure(errData))
      return [errData]
    }
  }
}

export const EditMoughataaApi = (moughataaId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMoughataaStart())
    const response = await put(`moughataa/${moughataaId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMoughataaSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMoughataaFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMoughataaFailure(errData))
      return [errData]
    }
  }
}

export const DeleteMoughataaApi = (moughataaId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusMoughataaStart())
    const response = await remove(`moughataa/${moughataaId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusMoughataaSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusMoughataaFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusMoughataaFailure(errData))
      return [errData]
    }
  }
}


export const clearMoughataaApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusMoughataaSuccess([]))
}
